import { render, staticRenderFns } from "./WebpartModalContent.vue?vue&type=template&id=fbf5328a"
import script from "./WebpartModalContent.ts?vue&type=script&lang=ts&external"
export * from "./WebpartModalContent.ts?vue&type=script&lang=ts&external"
import style0 from "./WebpartModalContent.vue?vue&type=style&index=0&id=fbf5328a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports